import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../store"

interface SnackbarItemState {
  active: boolean | null
  label: string
}

const initialState: SnackbarItemState = {
  active: null,
  label: "Letöltés...",
}

export const snackbarItemSlice = createSlice({
  name: "snackbarItem",
  initialState,
  reducers: {
    setActive: (state, action: PayloadAction<boolean>) => {
      state.active = action.payload
    },
    setLabel: (state, action: PayloadAction<string>) => {
      state.label = action.payload
    },
    resetLabel: (state) => {
      state.label = "Letöltés..."
    },
  },
})

export const { setActive, setLabel, resetLabel } = snackbarItemSlice.actions
export const selectSnackbarItem = (state: RootState) =>
  state.snackbarItem.active
export default snackbarItemSlice.reducer
